import React from 'react';
import { Card, Empty } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { Chart } from 'react-google-charts';
import { Button } from '../../../design-system';

const ROW_HEIGHT_PX = 40;
const MIN_CHART_HEIGHT = 250;
const COLORS = ['#1B1B1B', '#FED230'];

const OfficeBreakdownChart = ({ data = [], onSegmentClick, onExportCSV }) => {
    if (!data || data.length === 0) {
        return (
            <Card title="Office Breakdown" className="chart-card">
                <Empty description="No data available" image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </Card>
        );
    }

    const chartData = [['Office', 'Male', 'Female']];
    for (const item of data) {
        const label = item.country
            ? `${item.office} (${item.country})`
            : item.office;
        chartData.push([label, item.male, item.female]);
    }

    const options = {
        isStacked: true,
        legend: {
            position: 'top',
            alignment: 'center',
            textStyle: { fontSize: 12 },
        },
        hAxis: {
            title: 'Employees',
            minValue: 0,
            format: '0',
        },
        vAxis: { title: '' },
        colors: COLORS,
        chartArea: { width: '65%', height: '80%' },
        backgroundColor: 'transparent',
        bar: { groupWidth: '70%' },
    };

    const chartHeight = Math.max(MIN_CHART_HEIGHT, data.length * ROW_HEIGHT_PX);

    const chartEvents = onSegmentClick ? [
        {
            eventName: 'select',
            callback: ({ chartWrapper }) => {
                const selection = chartWrapper.getChart().getSelection();
                if (selection.length > 0) {
                    const row = selection[0].row;
                    const item = data[row];
                    if (item) onSegmentClick(item);
                }
            },
        },
    ] : [];

    return (
        <Card
            title="Office Breakdown"
            className="chart-card"
            extra={
                onExportCSV && (
                    <Button
                        size="small"
                        variant="secondary"
                        icon={<DownloadOutlined />}
                        onClick={() => onExportCSV('office', data)}
                        title="Download CSV"
                    />
                )
            }
        >
            <Chart
                chartType="BarChart"
                data={chartData}
                options={options}
                width="100%"
                height={`${chartHeight}px`}
                chartEvents={chartEvents}
            />
        </Card>
    );
};

export default OfficeBreakdownChart;
